<main-loader class="main-loader" *ngIf="loadingService.isLoading | async"></main-loader>

<div *ngIf="!router.url.startsWith('/login')">
    <router-outlet name="navbar"></router-outlet>
</div>
<div class="">
    <router-outlet></router-outlet>
    <router-outlet name="popup"></router-outlet>
</div>